import { useOutletContext } from 'react-router-dom'

export interface ShellContext {
  /** Сообщение в углу: каркас держит его один на все разделы. */
  toast: (message: string) => void
}

export function useShell(): ShellContext {
  return useOutletContext<ShellContext>()
}
